import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-x6 text-center" }
const _hoisted_2 = {
  key: 0,
  class: "my-x6 text-center text-silver"
}

import { useCheckout } from '../useCheckout';
import CheckoutDeliverable from './CheckoutDeliverable.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutStepDeliverables',
  setup(__props) {

const labels = useBlockLabels();
const { basket, step, updateStep, deliverableCount, invoiceAddress, hasSufficientPayments } = useCheckout();

// prevent bypassing deliverable steps by changing url param
const checkInitialStepValidity = () => {
    if (step.value > 0) {
        const inValidPreviousStep = basket.value.deliverables.find((deliverable, index) => index < step.value && !deliverable.isValid);
        if (inValidPreviousStep || invoiceAddress.value === undefined) {
            updateStep(0);
        }
    }
};

checkInitialStepValidity();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", null, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$dictionary.pluralize(_unref(deliverableCount), _unref(labels).deliverablesHeader, _unref(labels).deliverablesHeaderPlural)), 1),
    _createVNode(_TransitionGroup, { name: "o-anim-fade-500" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(basket).deliverables, (deliverable, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: deliverable.id
          }, [
            _createVNode(CheckoutDeliverable, {
              index: i,
              deliverable: deliverable
            }, null, 8, ["index", "deliverable"])
          ]))
        }), 128))
      ]),
      _: 1
    }),
    (_unref(step) + 1 < _unref(basket).deliverables.length && !_unref(hasSufficientPayments))
      ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(_unref(labels).paymentStepHeading), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})